import Icon from "../Icon";
import { esAdmin, esGestor, puedeEditarGuardias } from "../../utils";
import CalendarPage from "../../pages/CalendarPage";
import VacacionesView from "../../pages/VacacionesView";
import GuardiasView from "../../pages/GuardiasView";
import AsistenciasView from "../../pages/AsistenciasView";
import ActividadView from "../../pages/ActividadView";

// Las dos secciones que antes eran una sola con cinco sub-pestanas:
//   calendario  General (el calendario) y Guardias
//   fichajes    Vacaciones, Fichajes y Ahora (los dos ultimos, para quien coordina)
// Pestana y ano viven en App: los cambia tambien la redireccion de permisos y la
// carga de datos por ano. Cada seccion lleva su propia pestana (calTab es la de la
// seccion que se pinta), asi que pasar de una a otra no deja una pestana ajena.

export default function SeccionCalendario({ seccion = "calendario", calTab, setCalTab, calYear, setCalYear, verGuardias, currentUser, outlookEvents, agenda, calendarios, eventosCal, vacaciones, users, teams, festivos, guardias, showToast, setModal, setGuardia, aplicarPlanGuardias, limpiarGuardias, fichaje, diaInicial, alUsarDiaInicial }) {
  return (
    <>
      <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",padding:16,gap:12}}>
        {/* Sub-pestañas de la sección Calendario */}
        <div className="filters-bar" style={{display:"flex",gap:6,flexShrink:0}}>
          {(seccion==="fichajes"
            ? [["vacaciones","person-check-fill","Vacaciones"],
               ["asistencias","clock","Fichajes"],
            /* "Ahora" es la misma pregunta que Fichajes —quien
               trabaja y en que— pero a resolucion de minuto. Solo se
               ofrece a quien coordina: a un member el servidor le
               devuelve solo lo suyo, asi que no le diria nada. */
               ...(esGestor(currentUser)?[["actividad","people-fill","Ahora"]]:[])]
            : [["mes","calendar3","General"],
               ...(verGuardias?[["guardias","shield-check","Guardias"]]:[])]
            ).map(([k,ic,label])=>(
            <button key={k} onClick={()=>setCalTab(k)} className="btn"
              style={{padding:"6px 14px",borderRadius:9,cursor:"pointer",fontSize:12,fontFamily:"var(--font)",
                border:`1px solid ${calTab===k?"var(--accent)":"var(--border)"}`,
                background:calTab===k?"var(--accent-bg)":"var(--surface)",
                color:calTab===k?"var(--accent)":"var(--text2)",
                fontWeight:calTab===k?700:500,display:"flex",alignItems:"center",gap:6}}>
              <Icon name={ic} size={12} color={calTab===k?"var(--accent)":"var(--text2)"}/>{label}
            </button>
          ))}
        </div>

        {seccion==="calendario"&&calTab==="mes"&&(
          <CalendarPage
            outlookEvents={outlookEvents} agenda={agenda}
            calendarios={calendarios} eventosCal={eventosCal}
            currentUser={currentUser}
            onNuevoEvento={fecha=>setModal({type:"eventoCal", fecha})}
            onEditarEvento={ev=>setModal({type:"eventoCal", evento:ev})}
            onGestionarCalendarios={()=>setModal("calendarios")}/>
        )}

        {seccion==="fichajes"&&calTab==="vacaciones"&&(
          <VacacionesView
            vacaciones={vacaciones} users={users} teams={teams}
            festivos={festivos} currentUser={currentUser}
            year={calYear} setYear={setCalYear} isAdmin={esAdmin(currentUser)}
            onNuevoPeriodo={(fecha,personas)=>setModal({type:"vacacion", fecha, personas})}
            onEditarPeriodo={(p,personas)=>setModal({type:"vacacion", periodo:p, personas})}
            onImportar={()=>setModal("importarVacaciones")}/>
        )}

        {/* Entra todo el mundo: al que no manda el backend le devuelve
            solo sus propios fichajes (ambitoAsistencias en
            backend/lib/permisos.js). */}
        {seccion==="fichajes"&&calTab==="asistencias"&&(
          <AsistenciasView showToast={showToast} fichaje={fichaje}
            users={users} teams={teams} currentUser={currentUser}
            festivos={festivos} vacaciones={vacaciones}
            diaInicial={diaInicial} alUsarDiaInicial={alUsarDiaInicial}/>
        )}

        {seccion==="fichajes"&&calTab==="actividad"&&esGestor(currentUser)&&(
          <ActividadView
            users={users} teams={teams} currentUser={currentUser}
            vacaciones={vacaciones} showToast={showToast}/>
        )}

        {seccion==="calendario"&&calTab==="guardias"&&verGuardias&&(
          <GuardiasView
            guardias={guardias} users={users} teams={teams} festivos={festivos}
            currentUser={currentUser} isAdmin={puedeEditarGuardias(currentUser, teams)}
            year={calYear} setYear={setCalYear}
            vacaciones={vacaciones}
            onAsignar={setGuardia} onAplicarPlan={aplicarPlanGuardias} onLimpiar={limpiarGuardias}
            onImportar={()=>setModal("importarGuardias")}/>
        )}
      </div>
    </>
  );
}
